module.exports = __webpack_public_path__ + "static/media/5-c2.beb3a000.jpg";